import PlansComponent from '../components/plans';

export default function Plans() {
  return <PlansComponent />;
}
